/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');
var react = require('react');

var defaultOptions = {
  cancelOnUnmount: true
};

var useInterval = function useInterval(fn, milliseconds) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions;

  var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options || {});

  var timeout = react.useRef();
  var callback = react.useRef(fn);

  var _useState = react.useState(false),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      isCleared = _useState2[0],
      setIsCleared = _useState2[1];

  var clear = react.useCallback(function () {
    if (timeout.current) {
      clearInterval(timeout.current);
      setIsCleared(true);
    }
  }, []);
  react.useEffect(function () {
    if (typeof fn === 'function') {
      callback.current = fn;
    }
  }, [fn]);
  react.useEffect(function () {
    clear();

    if (typeof milliseconds === 'number') {
      timeout.current = setInterval(function () {
        callback.current();
      }, milliseconds);
    }
  }, [milliseconds]);
  react.useEffect(function () {
    return function () {
      if (opts.cancelOnUnmount) {
        clear();
      }
    };
  }, []);
  return [isCleared, clear];
};

exports.default = useInterval;
